import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const Inner = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.COLORS.WHITE};

  .coterm-tab {
    ${FLEX.FlexCenterCenter};
    gap: 4px;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }

  .card-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    padding-top: 20px;
    ${mediaQuery.isMobile} {
      grid-template-columns: 1fr;
    }
  }
  .ant-radio-group {
    width: 100%;
    background-color: ${({ theme }) =>
      theme.value === "light" ? theme.COLORS.LIGHTGRAY : theme.COLORS.BUTTONS3};
    border: 0;
    border-radius: 6px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    overflow: hidden;
    ${mediaQuery.isMobile} {
      grid-template-columns: 1fr;
    }

    > *:only-child {
      grid-column: 1 / -1;
    }

    > label {
      ${FLEX.FlexCenterCenter};
      display: inline-flex;
      padding: 10px;
      line-height: 1.25;
      height: auto;
      border: 0;
      font-weight: 500;
      border-radius: 0;
    }
  }
  .ant-radio-button-wrapper-checked {
    background-color: ${({ theme }) => theme.COLORS.BUTTONS2};
    &:before {
      display: none;
    }

    .coterm-tab {
      color: ${COLORS.WHITE};
    }
  }
`;

export const TopInfo = styled.div`
  background-color: ${({ theme }) => theme.COLORS.SELECTED}10;
  border: 2px solid ${({ theme }) => theme.COLORS.SELECTED};
  border-radius: 5px;
  width: 100%;
  padding: 20px;
  color: ${({ theme }) => theme.COLORS.WHITE};
  ${FLEX.FlexStartStart}
  gap: 6px;
`;

export const Card = styled.li`
  border-radius: 8px;
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-content: flex-start;

  h2 {
    font-weight: 600;
    font-size: ${calcRem(14)};
    text-transform: uppercase;
    ${FLEX.FlexStartCenter};
    gap: 6px;
  }

  .title {
    width: 100%;
    ${FLEX.FlexStartStart};
    gap: 10px;
    flex-direction: column;
  }

  ul.items {
    padding: 20px 0 0;
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 15px;
    width: 100%;
    h2 {
      padding-top: 5px;
    }

    > li {
      width: 100%;
      ${FLEX.FlexStartStart};
      flex-direction: column;
      gap: 6px;
    }
    .ant-input-number,
    .date-picker-wrapper {
      width: 100%;
    }

    .item-title {
      font-size: ${calcRem(13)};
      text-transform: uppercase;
      color: ${({ theme }) => theme.COLORS.WHITE}80;
      font-weight: 600;
      line-height: 1.25;
    }
  }

  .desc,
  .description {
    font-size: ${calcRem(13)};
    color: ${({ theme }) => theme.COLORS.WHITE}60;
    line-height: 1.25;

    strong {
      font-weight: 500;
      color: ${({ theme }) => theme.COLORS.SELECTED};
    }
  }
`;

export const CalculateCurrentCardStyled = {
  Card: styled(Card)``,
};

export const CalculateResultCardStyled = {
  Card: styled(Card)`
    background-color: ${({ theme }) => theme.COLORS.WHITE}08;
    padding: 20px;
    .value {
      font-weight: bold;
      font-size: ${calcRem(30)};
      ${FLEX.FlexStartCenter};
      gap: 6px;
    }

    li {
      padding: 15px;
      border: 1px solid ${({ theme }) => theme.COLORS.BORDER};
      border-radius: 8px;
      background-color: ${({ theme }) =>
        theme.value === "light" ? COLORS.WHITE : theme.COLORS.PRIMARY3};
    }
    .item-title {
      color: ${({ theme }) => theme.COLORS.TEXT};
    }

    .description {
      margin-top: -6px;
      margin-left: 20px;
    }
    .null-message {
      flex: 1;
      font-size: ${calcRem(16)};
      color: ${COLORS.RED};
      height: 100%;
      ${FLEX.FlexCenterCenter}
    }
  `,
};

export const CurrentCardStyled = {};
export const AddChannelCalculatorStyled = {};
